import { Icon, makeStyles } from '@material-ui/core';
import React from 'react';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { SearchableSelect } from '../../UI';
import { PropTypes } from 'prop-types';

const styles = makeStyles({
    mainContainer: {
        position: 'relative'
    },
    inputRoot: {
        width: '100%'
    },
    menuItemRoot: {
        width: '100%'
    },
    formTitleContainer: {
        textAlign: 'start',
        display: 'flex',
        alignItems: 'center'
    },
    selectContainer: {
        '& > div': {
            opacity: '0',
            position: 'absolute',
            top: '0',
            left: '0',
            right: '0',
            zIndex: '2'
        }
    }
});
const SelectionForm = ({ handleSelectForm, options, formTitle, optionsLabel }) => {
    const classes = styles();

    return (
        <div className={classes.mainContainer}>
            <div className={classes.formTitleContainer} dir="auto">
                {formTitle?.title}
                <Icon className={classes.arrowIcon} component={KeyboardArrowDownIcon} />
            </div>
            <div className={classes.selectContainer}>
                <SearchableSelect
                    id="selectionFrom"
                    width="100%"
                    optionsDirection="ltr"
                    optionalToUse
                    options={options}
                    optionsLabel={optionsLabel}
                    name="type"
                    setValue={(name) => handleSelectForm(name)}
                />
            </div>
        </div>
    );
};
SelectionForm.propTypes = {
    handleSelectForm: PropTypes.func,
    options: PropTypes.object,
    formTitle: PropTypes.object,
    optionsLabel: PropTypes.string
};
export default SelectionForm;
